const caseComboBox = () => {

    /* ---------------------------------------
        Container check 
    --------------------------------------- */
    
    const FormSection = document.querySelector('.FormSection#InvoiceProcessing');
    if (!FormSection) return;

    let section = document.querySelector('.sub-section#InvoiceProcessing > .sub-section-content > .ant-row');
    if(section && section.querySelector('#caseComboBox')) return;

    const currentInvoiceId = window.location.pathname.split('/').pop()
  
    /* ---------------------------------------
        Create wrapper
    --------------------------------------- */
    const wrapper = document.createElement('div');
    wrapper.id = 'caseComboBox';
    wrapper.className = 'ant-row ant-form-item';
    wrapper.style.marginBottom = '32px';
    wrapper.style.padding = '0 16px';
  
    /* Label */
    const label = document.createElement('div');
    label.className = 'ant-col ant-form-item-label';
    label.textContent = 'Vorgang';
  
    /* Content */
    const content = document.createElement('div');
    content.className = 'ant-col ant-col-24 ant-form-item-control';
    content.style.width = '100%';
    content.style.display = 'block';
  
    /* Root */
    const root = document.createElement('div');
    root.style.position = 'relative';
    root.style.width = '100%';
  
    /* ---------------------------------------
        DISPLAY INPUT (acts as search & display)
    --------------------------------------- */
    const display = document.createElement('input');
    display.type = 'text';
    display.className = 'ant-input';
    display.placeholder = 'Bitte auswählen oder eintippen...';
    display.style.width = '100%';
    display.style.borderRadius = '4px';
    display.style.padding = '6px 40px 6px 16px'; // Add right padding for delete button
    display.style.fontSize = '1.6rem';
    display.style.cursor = 'pointer';
    display.style.boxShadow = 'none';
  
    //mimicing the hover effect of the impower
    content.addEventListener('mouseover', () => {
      display.style.boxShadow = '0 0 0 2px black'  
      display.style.border = 'none'
      display.style.outline = 'none'
    });
    content.addEventListener('mouseout', () => display.style.boxShadow = '0 0 0 1px #d9d9d9');

    /* ---------------------------------------
        DELETE BUTTON (x) - appears only when case is associated
    --------------------------------------- */
    const deleteButton = document.createElement('button');
    deleteButton.innerHTML = '×';
    deleteButton.type = 'button';
    deleteButton.style.position = 'absolute';
    deleteButton.style.right = '8px';
    deleteButton.style.top = '50%';
    deleteButton.style.transform = 'translateY(-50%)';
    deleteButton.style.background = 'transparent';
    deleteButton.style.border = 'none';
    deleteButton.style.cursor = 'pointer';
    deleteButton.style.fontSize = '24px';
    deleteButton.style.color = '#999';
    deleteButton.style.width = '24px';
    deleteButton.style.height = '24px';
    deleteButton.style.display = 'none'; // Hidden by default
    deleteButton.style.lineHeight = '1';
    deleteButton.style.padding = '0';
    deleteButton.style.borderRadius = '2px';
    deleteButton.style.transition = 'color 0.2s';
    
    deleteButton.addEventListener('mouseover', () => {
      deleteButton.style.color = '#ff4d4f';
      deleteButton.style.background = '#fff2f0';
    });
    deleteButton.addEventListener('mouseout', () => {
      deleteButton.style.color = '#999';
      deleteButton.style.background = 'transparent';
    });

    deleteButton.addEventListener('click', async (e) => {
      e.stopPropagation(); // Prevent triggering dropdown
      await deleteCaseInvoiceAssociation();
    });
  
    /* ---------------------------------------
        DROPDOWN
    --------------------------------------- */
    const drop = document.createElement('div');
    drop.style.position = 'absolute';
    drop.style.top = '3 rem';
    drop.style.left = '0';
    drop.style.width = '100%';
    drop.style.maxHeight = '280px';
    drop.style.overflowY = 'auto';
    drop.style.background = '#fff';
    drop.style.border = '1px solid #d9d9d9';
    drop.style.borderRadius = '4px';
    drop.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
    drop.style.display = 'none';
    drop.style.zIndex = '9999';
    drop.style.marginTop = '4px';
  
    /* Options container */
    const opts = document.createElement('div');
  
    /* Spinner */
    const spinner = document.createElement('div');
    spinner.style.display = 'none';
    spinner.style.padding = '12px';
    spinner.style.textAlign = 'center';
    spinner.innerHTML = `
      <div style="
        border: 2px solid #f3f3f3;
        border-top: 2px solid #1890ff;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        animation: spin 1s linear infinite;
        margin: 0 auto;
      "></div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;
  
    drop.appendChild(spinner);
    drop.appendChild(opts);
  
    /* ---------------------------------------
        DATA Preparations (start empty)
    --------------------------------------- */
    let LIST = []; //list of cases
    const serviceProvidersList = new Map();
    let selectedServiceProviderId = null;
    let selectedPropertyId = null;
    let selectedCaseId = null;
    let caseInvoiceId = null; // Store the case-invoice association ID for deletion
    let originalDisplayValue = ''; // Store the original associated case value
    /* ---------------------------------------
        Fetch list of cases
    --------------------------------------- */
    async function initCaseList() {
      spinner.style.display = 'block';
      opts.style.display = 'none';
      await fetch(`/api/cases/get-choices-by-invoiceID?invoiceHrId=${currentInvoiceId}`, {
        headers: {
          'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(data => {
        LIST = data.cases;
        data.cases.forEach(case_=>{
          if (case_.serviceProviders && typeof case_.serviceProviders === 'object') {
            Object.entries(case_.serviceProviders).forEach(([id, sp])=>{
              sp && serviceProvidersList.set(id, sp.name);
            });
          }
        });
        if(data.counterpartContactId){
          const stringifiedId = data.counterpartContactId.toString();
          if(serviceProvidersList.has(stringifiedId)){
            selectedServiceProviderId = stringifiedId;
          }
        }
        if(data.associatedCase){
          // Handle both array and object formats
          const associatedCase = Array.isArray(data.associatedCase) ? data.associatedCase[0] : data.associatedCase;
          if(associatedCase && associatedCase.caseId){
            selectedCaseId = associatedCase.caseId;
            caseInvoiceId = associatedCase.id; // Store the case-invoice association ID
          }
        }
        if(data.propertyId){
          selectedPropertyId = data.propertyId;
        }
        
        // Display selected case if it exists
        if(selectedCaseId !== null && caseInvoiceId !== null){
          const selectedCase = LIST.find(case_ => case_.id === selectedCaseId);
          if(selectedCase){
            const title = `${selectedCase.companyCode}-${selectedCase.companyCaseId} ${selectedCase.title}`;
            display.value = title;
            originalDisplayValue = title; // Store the original associated case value
            deleteButton.style.display = 'block'; // Show delete button when case is associated
          }
        }
        
        renderServiceProviderOptions(); 
      })
      .catch(error => {
        console.error('Error fetching cases:', error);
      });
  
      spinner.style.display = 'none';
      opts.style.display = 'block';
  
      renderOptions('');
    }
  
    /* ---------------------------------------
        Save case-invoice association
    --------------------------------------- */
    async function saveCaseInvoiceAssociation(caseId) {

      try {         
       //disbale click on the wrapper to prevent multiple clicks
        wrapper.style.cursor = 'not-allowed';
        wrapper.style.opacity = '0.5';
        wrapper.style.pointerEvents = 'none';
        const response = await fetch('/api/cases/associate-invoice', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            caseId: caseId,
            invoiceHrId: currentInvoiceId
          })
        });

        const data = await response.json();
        
        if (!response.ok) {
          console.error('Error saving case-invoice association:', data.error);
          return false;
        }

        // Update caseInvoiceId from the response
        if (data.association && data.association.id) {
          caseInvoiceId = data.association.id;
          deleteButton.style.display = 'block'; // Show delete button after successful save
        }

        console.log('Case-invoice association saved:', data.message);
        return true;
      } catch (error) {
        console.error('Error saving case-invoice association:', error);
        return false;
      } finally {
        //enable click on the wrapper again
        wrapper.style.cursor = 'pointer';
        wrapper.style.opacity = '1';
        wrapper.style.pointerEvents = 'auto';
      }
    }

    /* ---------------------------------------
        Delete case-invoice association
    --------------------------------------- */
    async function deleteCaseInvoiceAssociation() {
      if (!caseInvoiceId) {
        console.error('No case-invoice association ID to delete');
        return false;
      }

      try {
        // Disable click on the wrapper (same as save)
        wrapper.style.cursor = 'not-allowed';
        wrapper.style.opacity = '0.5';
        wrapper.style.pointerEvents = 'none';
        
        const response = await fetch(`/api/cases/associate-invoice?caseInvoiceId=${caseInvoiceId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
            'Content-Type': 'application/json'
          }
        });

        const data = await response.json();
        
        if (!response.ok) {
          console.error('Error deleting case-invoice association:', data.error);
          throw new Error(data.error);
        }

        // Clear the association
        selectedCaseId = null;
        caseInvoiceId = null;
        originalDisplayValue = '';
        display.value = '';
        display.style.color = '#000';
        display.style.boxShadow = '0 0 0 1px #d9d9d9';
        deleteButton.style.display = 'none'; // Hide delete button after successful deletion

        console.log('Case-invoice association deleted:', data.message);
        return true;
      } catch (error) {
        console.error('Error deleting case-invoice association:', error);
        // Show error on display
        display.style.boxShadow = '0 0 0 2px red';
        display.style.color = 'red';
        display.value = 'Fehler beim Löschen der Zuordnung';
        return false;
      } finally {
        wrapper.style.cursor = 'pointer';
        wrapper.style.opacity = '1';
        wrapper.style.pointerEvents = 'auto';
      }
    }

    /* ---------------------------------------
        Render options (list of cases)
    --------------------------------------- */
    function renderOptions(filter) {
      opts.innerHTML = '';

      const filteredCases = LIST
        .filter(case_ => {
          if(filter) return true; 
          //if no filter is applied, filter the cases by selected service provider and property
          if(selectedServiceProviderId !== null || selectedPropertyId !== null){
            if(selectedPropertyId !== null){
              if(case_.propertyId.toString() !== selectedPropertyId.toString()){
                return false;
              }
            }
            if(selectedServiceProviderId !== null){
              if(!case_.serviceProviders[selectedServiceProviderId]){
                return false;
              }
            }
          }
          return true;
        })
        .filter(case_ => {
          const title= `${case_.companyCode}-${case_.companyCaseId} ${case_.title}`;
          const SearchableTitle = `${title} ${case_.customer}`;
          // apply filter on the whole title (case title and customer name)
          return SearchableTitle.toLowerCase().includes(filter.toLowerCase());
        });

      // Show "No case found" message if filter is applied and results are empty
      if (filter && filter.trim() !== '' && filteredCases.length === 0) {
        const noResultsMessage = document.createElement('div');
        noResultsMessage.textContent = 'Keine Vorgang gefunden';
        noResultsMessage.style.padding = '12px';
        noResultsMessage.style.textAlign = 'center';
        noResultsMessage.style.color = '#999';
        noResultsMessage.style.fontSize = '1.4rem';
        opts.appendChild(noResultsMessage);
        return;
      }

      filteredCases.forEach(case_ => {
        const title= `${case_.companyCode}-${case_.companyCaseId} ${case_.title}`;
        const item = document.createElement('div');
        item.textContent = title;
        item.style.padding = '6px 8px';
        item.style.cursor = 'pointer';
        item.style.fontSize = '1.6rem'; 
        item.style.fontWeight = 'bold';
        //add subtitle with contact name
        const subtitle = document.createElement('div');
        subtitle.textContent = 'Kunde: ' + (case_.customer || 'Nicht bekannt');
        subtitle.style.fontSize = '1.2rem';
        subtitle.style.color = ' #999';
        subtitle.style.fontWeight = 'normal';
          item.appendChild(subtitle);

        item.addEventListener('mouseover', () => item.style.background = '#f5f5f5');
        item.addEventListener('mouseout', () => item.style.background = '#fff');

        item.addEventListener('click', async () => {
          display.value = title;
          display.style.color = '#000';
          display.style.boxShadow = '0 0 0 1px #d9d9d9'; 
          selectedCaseId = case_.id;
          drop.style.display = 'none';

          
          // Save the association to backend
          const saved = await saveCaseInvoiceAssociation(case_.id);
          if (!saved) {
            // Optionally show an error message to the user
            //set display.style.boxShadow to red for 2 seconds 
            display.style.boxShadow = '0 0 0 2px red';
            display.style.color = 'red';
            display.value = 'Fehler beim Speichern der Daten';
          } else {
            // Update the original display value to the newly selected case
            originalDisplayValue = title;
          }
        });

        opts.appendChild(item);
      });
    }
  
    /* ---------------------------------------
        EVENTS
    --------------------------------------- */
  
    // Toggle dropdown
    display.addEventListener('click', (e) => {
      e.stopPropagation();
      drop.style.display = drop.style.display === 'none' ? 'block' : 'none';
      if(drop.style.display === 'block'){
        display.value = '';
        deleteButton.style.display = 'none';
      }
      display.select();
    });
  
    // Search inside display input
    display.addEventListener('input', (e) => {
      renderOptions(e.target.value);
    });
  
    // Click outside closes dropdown
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) {
        drop.style.display = 'none';
        if(selectedCaseId !== null && caseInvoiceId !== null){
          deleteButton.style.display = 'block';
        }
        
        // Check if the current display value matches any case in the list
        const currentValue = display.value.trim();
        const matchesCase = LIST.some(case_ => {
          const title = `${case_.companyCode}-${case_.companyCaseId} ${case_.title}`;
          return title === currentValue;
        });
        
        // If the value doesn't match any case, reset to the original associated case or empty string
        if (!matchesCase) {
          display.value = originalDisplayValue;
          renderOptions('')
        }
      }
    });
  
    root.appendChild(display);
    root.appendChild(deleteButton);
    root.appendChild(drop);



    content.appendChild(root);

    wrapper.appendChild(label);
    wrapper.appendChild(content);

    section.appendChild(wrapper);
    
    //listen to the accordion click event on the FormSection
    //when the accordion is clicked, the .sub-section is added or removed from the DOM
    FormSection.addEventListener('click', (e) => {
      //on the momemnt of click the FormSection is not yet fully rendered
      //so we need Defer execution to allow DOM to update after click handler
      setTimeout(() => {
        //if the caseComboBox is already in the DOM, skip the execution
        if (FormSection.querySelector('#caseComboBox')) return;
        section = FormSection.querySelector('.sub-section#InvoiceProcessing > .sub-section-content > .ant-row');
        if (section) {
          section.appendChild(wrapper);
        }
      }, 0);
    });

  
    initCaseList();
  };
  